const API_BASE = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5001/api';

const authHeaders = () => {
  const adminToken = localStorage.getItem('adminToken');
  return {
    'Content-Type': 'application/json',
    ...(adminToken ? { Authorization: `Bearer ${adminToken}` } : {}),
  };
};

const parse = async (res) => {
  const data = await res.json();
  if (!res.ok || !data?.success) throw new Error(data?.message || 'เกิดข้อผิดพลาด');
  return data;
};

export const newsAPI = {
  listPublic: async () => parse(await fetch(`${API_BASE}/news`)),
  getPublicById: async (id) => parse(await fetch(`${API_BASE}/news/${id}`)),
  listAdmin: async () => parse(await fetch(`${API_BASE}/news/admin/list`, { headers: authHeaders() })),
  create: async (payload) => parse(await fetch(`${API_BASE}/news/admin`, { method: 'POST', headers: authHeaders(), body: JSON.stringify(payload) })),
  update: async (id, payload) => parse(await fetch(`${API_BASE}/news/admin/${id}`, { method: 'PUT', headers: authHeaders(), body: JSON.stringify(payload) })),
  remove: async (id) => parse(await fetch(`${API_BASE}/news/admin/${id}`, { method: 'DELETE', headers: authHeaders() })),
};

